import { Box, Typography, Paper } from "@mui/material";

const BudgetCalculationDisplay = ({ 
  allocatedBudget, 
  currentBudget, 
  newBudgetValue,
  existingTotalBudget = 0
}) => {
  // Calculate remaining budget
  const totalBudgetAfterChange = existingTotalBudget - (currentBudget || 0) + (newBudgetValue || 0);
  const remainingBudget = allocatedBudget - totalBudgetAfterChange;

  return (
    <Paper sx={{ p: 2, mt: 2, bgcolor: '#f5f5f5' }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 'bold', mb: 1 }}>
        Budget Calculation Preview
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body2">Allocated Budget:</Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            ${allocatedBudget.toLocaleString()}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="body2">Total Budget After Change:</Typography>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            ${totalBudgetAfterChange.toLocaleString()}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
            Remaining Budget:
          </Typography>
          <Typography 
            variant="body2" 
            sx={{ 
              fontWeight: 'bold',
              color: remainingBudget >= 0 ? '#4caf50' : '#f44336'
            }}
          >
            ${Math.abs(remainingBudget).toLocaleString()}
            {remainingBudget < 0 ? ' (Exceeded)' : ''}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default BudgetCalculationDisplay; 